import * as yup from 'yup';
import * as XLSX from 'xlsx';

const schema = yup.object().shape({
  supplierId: yup.string().label('supplierId').required(),
  palletId: yup.string().label('palletId').required(),
  shippingType: yup.string().label('shippingType').required(),
  containerId: yup
    .string()
    .label('containerId')
    .when('shippingType', {
      is: (val) => val === 'Sea' || val === 'Land',
      then: yup.string().required(),
    }),
  palletMaxWidth: yup.number().label('palletMaxWidth').when('shippingType', {
    is: 'Air',
    then: yup.number().required(),
  }),
  palletMaxHeight: yup.number().label('palletMaxHeight').when('shippingType', {
    is: 'Air',
    then: yup.number().required(),
  }),
  palletMaxLength: yup.number().label('palletMaxLength').when('shippingType', {
    is: 'Air',
    then: yup.number().required(),
  }),
  maxKg: yup.number().label('maxKg'),
  warehouseOwnerId: yup.string().label('warehouseOwnerId'),
  warehouses: yup.array().label('warehouses').required().min(1, 'At least one warehouse is required'),
});

const validateColumn = (rows, columnIndex, columnName) => {
  const invalidRows = rows.slice(1).filter(row => !row[columnIndex] || row[columnIndex].toString().trim() === "");
  if (invalidRows.length > 0) {
    return `Some rows have invalid or missing '${columnName}' values.`;
  }
  return null;
};

const expectedHeaders = ["Barcode Piece", "Barcode Carton", "Name", "Expiration Date", "Order (cartons)"];

export const validateFileStructure = async (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      const headers = rows[0];
      const missingHeaders = expectedHeaders.filter((header) => !headers.includes(header));

      if (missingHeaders.length > 0) {
        return resolve({ valid: false, error: `Missing columns: ${missingHeaders.join(", ")}` });
      }

      const barcodePieceIndex = headers.indexOf("Barcode Piece");
      const nameIndex = headers.indexOf("Name");
      const expirationDateIndex = headers.indexOf("Expiration Date");
      const orderCartonsIndex = headers.indexOf("Order (cartons)");

      const barcodePieceError = validateColumn(rows, barcodePieceIndex, "Barcode Piece");
      const nameError = validateColumn(rows, nameIndex, "Name");
      const expirationDateError = validateColumn(rows, expirationDateIndex, "Expiration Date");
      const orderCartonsError = validateColumn(rows, orderCartonsIndex, "Order (cartons)");

      if (barcodePieceError) { return resolve({ valid: false, error: barcodePieceError }); }
      if (nameError) { return resolve({ valid: false, error: nameError }); }
      if (expirationDateError) { return resolve({ valid: false, error: expirationDateError }); }
      if (orderCartonsError) { return resolve({ valid: false, error: orderCartonsError }); }

      resolve({ valid: true });
    };
    reader.readAsArrayBuffer(file);
  });
};

export default schema;
